// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"023592e7","471":"715ae55f"}[chunkId] + ".chunk.css";
};